import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, STRING, UUID, ITEM, INTEGER } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'
import ServiceRateType from '@/plugins/sdk/resources/Dictionary/ServiceRateType'
import CarrierType from '@/plugins/sdk/resources/Dictionary/CarrierType'
import CarrierSetting from '@/plugins/sdk/resources/Account/CarrierSetting'

export default class extends Resource {
  static name = 'account_carrierservicesetting'

  static get fields () {
    return {
      id: new UUID(),
      item_prefix: new STRING(),
      item_min: new STRING(),
      item_max: new STRING(),
      item_next_id: new STRING(),
      cubic: new STRING(),
      autobook: new BOOLEAN(),
      extra: new STRING(),
      transit_modifier: new INTEGER(0),
      service_labelqty: new STRING(),
      service_printer: new STRING(),
      service_spinst: new STRING(),
      crm_pickuptype: new BOOLEAN(),
      crm_pickupnotes: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      hashed: new BOOLEAN(),
      account: new ITEM(Account),
      carrier_service: new ITEM(CarrierService),
      service_rate_type: new ITEM(ServiceRateType),
      carrier_type: new ITEM(CarrierType),
      carrier_setting: new ITEM(CarrierSetting),
      service_tracking_notifications: new BOOLEAN()
    }
  }
}
